/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        var overlayMenuActive = $('.primary-nav-overlay');
        overlayMenuActive.hide();

        var hamburger = $('.hamburger');

        hamburger.click(function () {
          hamburger_cross();
        });

        function hamburger_cross() {
          var body = $('body');
          var primaryNavOverlay = $('.primary-nav-overlay');

          if (hamburger.hasClass('is-closed')) {
            hamburger.removeClass('is-closed');
            hamburger.addClass('is-open');

            $('.primary-nav-overlay').addClass('is-active');
            $('.primary-nav-overlay.is-active').show();
            $('body').addClass('menu-open');
            $('body').css({
              'overflow': 'hidden'
            });

          } else {
            hamburger.removeClass('is-open');
            hamburger.addClass('is-closed');

            $('.primary-nav-overlay').removeClass('is-active');
            $('.primary-nav-overlay').hide();
            $('body').removeClass('menu-open');
            $('body').css({
              'overflow': 'auto'
            });
          }
        }


        $('body').on('click','button.primary-nav-menu-toggle', function (e) {
          var that = $(this),
              body = $('body'),
              primaryNavOverlay = $('.primary-nav-overlay');

          if (!that.hasClass('active')) {
              primaryNavOverlay.addClass('is-active');

              // if BODY has class of '.menu-open' then it will add 'overflow: hidden;' in css
              $('.primary-nav-overlay.is-active').show();
              body.addClass('menu-open');
              body.css({
                'overflow': 'hidden'
              });
            $('.primary-nav-menu-toggle').html('close');
          } else {
            $('.primary-nav-overlay').hide();
            body.removeClass('menu-open');
            body.css({
              'overflow': 'auto'
            });
            $('.primary-nav-menu-toggle').html('menu');
          }
          $('.primary-nav-menu-toggle').toggleClass('active');
        });

        // Banner Owl Carousel
        var banner       = $('#banner');
        if (banner.hasClass('owl-carousel')) {
          banner.on('initialized.owl.carousel', function (event) {
          }).owlCarousel({
            loop: true,
            nav: true,
            dots: true,
            items: 1,
            navText: '',
            navSpeed: 1200,
            autoplay: true
          });
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

    //Single carousel
    $('#flexible-image-gallery').owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      navText:["",""],
      navSpeed: 500,
      items:1,
      autoplay: true
    });

    $('.background-image, .gallery-image').Lazy({
      scrollDirection: 'vertical',
      effect: 'fadeIn',
      effectTime: 500,
      threshold: 250,
      onError: function(element) {
        console.log('error loading ' + element.data('src'));
      }
    });

    // jQuery('#overlay').click(function () {
    //   jQuery(this).hide();
    //   jQuery('#youtube_id').get(0).playVideo();

    // });

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


// 2. This code loads the IFrame Player API code asynchronously.
var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.
var player;
function onYouTubeIframeAPIReady() {
  var youtubeId = jQuery(".video-background").data("youtubeId");
  var youtubeContainerWidth = jQuery('.youtube-div').width();
  var youtubeContainerHeight = jQuery('.youtube-div').height();
  player = new YT.Player('player', {
    height: youtubeContainerHeight,
    width: youtubeContainerWidth,
    videoId: youtubeId,
    playerVars: {
      playsinline: 1,
      autoplay: 0,
      controls: 0, // Hides the player controls
      autohide: 1,
      enablejsapi: 1,
      loop: 1,
      disablekb: 1,
      fs: 0,
      modestbranding: 1,// youtube logo
      showinfo: 0,
      rel: 0, // Disable related videos
      playlist: youtubeId
    },
    events: {
      'onStateChange': onYoutubePlayerStateChange,
      // 'onReady': onPlayerReady,
    }
  });

  // function onPlayerReady(event) {
  //   console.log('Ready.');
  //   // document.querySelector('.ytp-button').style.background = 'white';
  // }

  function onYoutubePlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING) { // fade out #_buffering-background
      document.querySelector('.youtube-div').dataset.after = '';
      document.querySelector('.youtube-overlay').style.opacity = 0;
      document.querySelector('.youtube-div > span').style.display = 'none';
      /*player.mute();*/

    }
    if (event.data == YT.PlayerState.PAUSED) { // fade out #_buffering-background
      document.querySelector('.youtube-overlay').style.opacity = 1;
      document.querySelector('.youtube-div > span').style.display = 'block';
    }
  }
}
function vidRescale() {
  var youtubeContainerWidth = jQuery('.youtube-div').width();
  var youtubeContainerHeight = jQuery('.youtube-div').height();
  player.setSize(youtubeContainerWidth, youtubeContainerHeight);
}
window.addEventListener('resize', function () {
  vidRescale();
});
